import Api from './api'

const isUniqueEmail = async (value, [currentEmail]) => {
  let valid = false
  if (currentEmail && (value === currentEmail)) {
    valid = true
  } else {
    const response = await Api.methods.apiPost('validate/email', {
      email: value
    })
    valid = response.valid
  }
  return {
    valid: valid
  }
}

const isUniqueNick = async (value, [currentNickname]) => {
  let valid = false
  if (currentNickname && (value === currentNickname)) {
    valid = true
  } else {
    const response = await Api.methods.apiPost('validate/nickname', {
      nickname: value
    })
    valid = response.valid
  }

  return {
    valid: valid
  }
}

const isUniqueRewardLevel = async (value, [rewardId]) => {
  let valid = false
  const response = await Api.methods.apiPost('validate/rewardLevel', {
    amount: value * 100,
    rewardId: rewardId
  })
  valid = response.valid
  return {
    valid: valid
  }
}

const rules = {
  'uniqueEmail': {
    validate: isUniqueEmail,
    getMessage: () => {
      return 'This Email is already taken.'
    }
  },
  'uniqueNickname': {
    validate: isUniqueNick,
    getMessage: () => {
      return 'The nickname is already taken.'
    }
  },
  'isUniqueRewardLevel': {
    validate: isUniqueRewardLevel,
    getMessage: () => {
      return 'Dear Star, this reward already exists. Please choose a different amount.'
    }
  }
}
// export an 'install' function.
export default (VeeValidate) => {
  // Failed to add this rule to the above structure.
  // Passing data did not work.
  const isPasswordStrong = async value => {
    const response = await Api.methods.apiPost('validate/password', {
      password: value
    })
    return {
      valid: response.valid,
      data: {
        message: response.feedback.warning || 'Password is too weak.',
        feedback: response.feedback,
        score: response.score
      }
    }
  }

  VeeValidate.Validator.extend('passwordStrength', {
    validate: isPasswordStrong,
    getMessage: (field, params, data) => {
      if (data) {
        return {
          message: data.message,
          feedback: data.feedback,
          score: data.score
        }
      }
    }
  })

  // for every rule we defined above.
  Object.keys(rules).forEach(rule => {
    //  add the rule.
    VeeValidate.Validator.extend(rule, rules[rule])
  })
}



// WEBPACK FOOTER //
// ./src/lib/validation.js